<template>
    <div>
        <WritersList />
    </div>
</template>

<script>
export default {
  name: 'MyWriters',
  components: {
    WritersList: () => import('@/modules/Writers/components/writersList'),
  },
  data() {
    return {}
  },
}
</script>